import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

export default function NewCricBuddyPortfolioVenueSideFeatures() {
  const data = [
    "Comprehensive dashboard: view and manage all bookings, venues, staff, and earnings at a glance.",
    "Real-time notifications for new bookings or cancellations within a 5-minute decision window.",
    "Tools to adjust deposits, prices, and set special offers/coupons.",
    "Manage offline and recurring bookings, calendar, and withdrawal history.",
  ];

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  const isMobile = window.innerWidth < 768;

  const [highlightIndex, setHighlightIndex] = useState(-1);

  useEffect(() => {
    let i = 0;
    const interval = setInterval(() => {
      setHighlightIndex(i);
      i = (i + 1) % data.length; // loop back to start
    }, 3000); // every 3 seconds
    return () => clearInterval(interval);
  }, [data.length]);

  return (
    <div className="horizontal-padding pb-5 pe-0" ref={ref}>
      <div className="border-el-wrapper border-el-wrapper-white">
        <span className="b1"></span>
        <span className="b2"></span>
        <span className="b3"></span>
        <span className="b4"></span>

        <div className="row">
          {/* Left Section */}
          <motion.div
            className="col-md-6 col-12 mb-4 mb-md-0"
            initial={
              isMobile ? { y: 100, opacity: 0 } : { x: -100, opacity: 0 }
            }
            animate={inView ? { x: 0, y: 0, opacity: 1 } : {}}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            <h2 className="cb-cr-heading mb-4">Venue Owner Side Features</h2>
            <ul className="cb-venue-side-list">
              {data.map((val, idx) => (
                <li
                  className={`cb-cr-h3 ${
                    highlightIndex === idx ? "active-highlight" : ""
                  }`}
                  key={idx}
                >
                  {val}
                </li>
              ))}
            </ul>
          </motion.div>

          {/* Right Section */}
          <motion.div
            className="col-md-6 col-12 text-center cb-venue-side-right-section"
            initial={isMobile ? { y: 100, opacity: 0 } : { x: 100, opacity: 0 }}
            animate={inView ? { x: 0, y: 0, opacity: 1 } : {}}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            <div className="cb-venue-side-phone-frame-container">
              {/* Phone frame (SVG) */}
              <img
                src="/images/CB/PhoneFrame.svg"
                alt="Phone Frame"
                className="cb-venue-side-phone-frame"
              />

              {/* Video inside the frame */}
              <video
                src="/images/CB/VenueSideVideo.mp4"
                autoPlay
                loop
                muted
                playsInline
                className="cb-venue-side-phone-video"
              ></video>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
}
